"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.maxBytecodeSize = exports.gasPerPubdataDefault = void 0;
const number_js_1 = require("../../constants/number.js");
exports.gasPerPubdataDefault = 50000n;
exports.maxBytecodeSize = number_js_1.maxUint16 * 32n;
//# sourceMappingURL=number.js.map